
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/channels/[id]/featured",
      function () {
        return require("private-next-pages/channels/[id]/featured.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/channels/[id]/featured"])
      });
    }
  